import DotSearch from "./DotSearch/index.js";
class Index {
    rc;
    _parent;
    scimUserId;
    constructor(_parent, scimUserId = null) {
        this._parent = _parent;
        this.rc = _parent.rc;
        this.scimUserId = scimUserId;
    }
    path(withParameter = true) {
        if (withParameter && this.scimUserId !== null) {
            return `${this._parent.path()}/Users/${this.scimUserId}`;
        }
        return `${this._parent.path()}/Users`;
    }
    /**
     * Returns the list of users satisfying search criteria
     * HTTP Method: get
     * Endpoint: /scim/{version}/Users
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     */
    async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a new user
     * HTTP Method: post
     * Endpoint: /scim/{version}/Users
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     */
    async post(scimUser, restRequestConfig) {
        const r = await this.rc.post(this.path(false), scimUser, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns a user by ID
     * HTTP Method: get
     * Endpoint: /scim/{version}/Users/{scimUserId}
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     */
    async get(restRequestConfig) {
        if (this.scimUserId === null) {
            throw new Error("scimUserId must be specified.");
        }
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates a user
     * HTTP Method: put
     * Endpoint: /scim/{version}/Users/{scimUserId}
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     */
    async put(scimUser, restRequestConfig) {
        if (this.scimUserId === null) {
            throw new Error("scimUserId must be specified.");
        }
        const r = await this.rc.put(this.path(), scimUser, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes a user
     * HTTP Method: delete
     * Endpoint: /scim/{version}/Users/{scimUserId}
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     */
    async delete(restRequestConfig) {
        if (this.scimUserId === null) {
            throw new Error("scimUserId must be specified.");
        }
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates a user (partial update)
     * HTTP Method: patch
     * Endpoint: /scim/{version}/Users/{scimUserId}
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     */
    async patch(scimUserPatch, restRequestConfig) {
        if (this.scimUserId === null) {
            throw new Error("scimUserId must be specified.");
        }
        const r = await this.rc.patch(this.path(), scimUserPatch, undefined, restRequestConfig);
        return r.data;
    }
    dotSearch() {
        return new DotSearch(this);
    }
}
export default Index;
